<ng-container *transloco="let t;">
    <div class="d-flex justify-content-center align-items-center vh-100">
        <a class="brand-logo" href="javascript:void(0);">
            <img src="assets/images/logo/blueVariantLogoSimplesignSvg.svg" alt="brand-logo" height="42" /></a>
        <div class="col-lg-3">
            <h2 class="card-title fw-bold text-center mb-1">{{ t('reset password title (reset password page) - Reset
                your password')
                }}</h2>

            <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
                <div class="alert-body">
                    <p>{{ error }}</p>
                </div>
            </ngb-alert>

            @if (changePasswordSucceeded) {
            <ngb-alert [type]="'success'" [dismissible]="false">
                <div class="alert-body">
                    <p>{{t('Change password success message (Reset password page) - Password has been changed
                        successfully.
                        You
                        will be redirected into login page in n seconds', { seconds: redirectTimeout }) }}</p>
                </div>
            </ngb-alert>
            } @else {
            <form class="auth-register-form" autocomplete="off" [formGroup]="changePasswordForm"
                (ngSubmit)="onSubmit()">
                <div class="form-group text-center">
                    <label for="password" class="form-label fw-bold">{{ t('new password - label (Reset password page) -
                        New
                        Password') }}</label>
                    <app-password-field #password formControlName="password" id="password"
                        tabindex="3"></app-password-field>
                    <ng-container *ngTemplateOutlet="errorMessage; context: {
                            invalid: changePasswordForm.invalid,
                            submitted: submitted,
                            formField: changePasswordForm.controls['password'],
                            fieldName:t('Password - label (general) - Password')
                        }"></ng-container>
                </div>

                <div class="form-group text-center">
                    <label for="confirm-password" class="form-label fw-bold">{{ t('Confirm Password - label
                        (general) - Confirm
                        password') }}</label>
                    <app-password-field formControlName="confirmPassword" id="confirm-password"
                        tabindex="3"></app-password-field>
                    <ng-container *ngTemplateOutlet="errorMessage; context: {
                            invalid: changePasswordForm.invalid,
                            submitted: submitted,
                            formField: changePasswordForm.controls['confirmPassword'],
                            fieldName:t('Confirm Password - label (general) - Confirm password')
                        }"></ng-container>
                </div>
                <div class="form-group">
                    <div *ngIf="submitted && changePasswordForm.invalid" class="invalid-feedback"
                        [ngClass]="{ 'd-block': submitted && changePasswordForm.invalid }">
                        <div *ngIf="changePasswordForm.hasError('passwordsMustMatch')">
                            {{ t('Fields must match each other (field matches validation) - a field must match b field',
                            {
                            fieldA: t('Password - label (general) - Password'), fieldB: t('Confirm Password - label
                            (general) -
                            Confirm password') })
                            }}
                        </div>
                    </div>
                </div>

                <button [disabled]="loading" class="btn btn-primary btn-block" tabindex="4" rippleEffect>
                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>{{ t('reset password
                    button text (Reset password page)- Reset password') }}
                </button>
            </form>
            }

            <ng-template #errorMessage let-formField="formField" let-submitted="submitted" let-invalid="invalid"
                let-fieldName="fieldName">
                <div *ngIf="submitted && invalid" class="invalid-feedback"
                    [ngClass]="{ 'd-block': submitted && invalid }">
                    <div *ngIf="formField.hasError('required')">{{ t('Field required (form validation) - Field name is required', { fieldName: fieldName }) }}</div>
                    <div *ngIf="formField.hasError('pattern')">
                        {{ t('New Password field validation message (Change password - section) - New Password must contain more than 8 characters 1 numeric 1 upper case letter and 1 special character') }}
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</ng-container>